<template>
  <div class="signContent">
    <div style="height:46px;text-align:left;width:1160px;margin:0 auto;">
      <img
        src="../../assets/img/main/TC-logo1.png"
        alt=""
        style="height:45px;width:160px;vertical-align:middle;cursor:pointer;"
        @click="matinTap"
      />
    </div>
    <div class="signindex">
      <p class="botcolor">
        {{$t('user.sign')}}
      </p>
      <div class="headerLogin">
        {{$t('user.already')}}
        <span
          class="cols"
          @click="loginTap"
        > {{$t('user.logintap')}}</span>
      </div>
      <div class="logincontent">
        <div class="headerTitle">
          <div
            :class="tapflag ? 'active' : 'one'"
            @click="tapphone"
          >
            {{$t('user.signphone')}}
          </div>
          <div
            :class="tapflags ? 'actives' : 'two'"
            @click="tapemail"
          >
            {{$t('user.signemail')}}
          </div>
        </div>
        <div
          class="formsign"
          v-if="tapflag"
        >
          <signPhone ref="signphone"></signPhone>
        </div>
        <div
          class="formsign"
          v-else
        >
          <signEmail ref="signemail"></signEmail>
        </div>
      </div>
    </div>
    <!-- 注册成功弹窗 -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <img
        style="width:60px;height:60px;"
        src="../../assets/img/right.png"
        alt=""
      />
      <div>{{$t('user.success')}}</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="backlogin"
        >{{$t('user.backlogin')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import signPhone from "@/components/user/signPhone";
import signEmail from "@/components/user/signEmail";
export default {
  components: {
    signPhone,
    signEmail
  },
  data() {
    return {
      activeName: "first",
      signStatus: true,
      fastStatus: false,
      tapflag: true,
      tapflags: false,
      centerDialogVisible: false
    };
  },
  created() {},
  mounted() {},
  methods: {
    loginTap() {
      this.$router.push({
        name: "login"
      });
    },
    matinTap() {
      this.$router.push({
        name: "main"
      });
    },
    handleClick(val) {
      if (val.name == "first") {
        this.signStatus = true;
      } else {
        this.fastStatus = true;
      }
    },
    tapphone() {
      this.tapflag = true;
      this.tapflags = false;
      // 清除自动触发的表单验证
      this.$nextTick(() => {
        this.$refs.signphone.rulesp();
      });
    },
    tapemail() {
      this.tapflag = false;
      this.tapflags = true;
      console.log(this.tapflags);
      // 清除自动触发的表单验证
      this.$nextTick(() => {
        this.$refs.signemail.rulese();
      });
    },
    // 注册成功后登录
    backlogin() {
      this.centerDialogVisible = false;
      this.$router.push({
        name: "main"
      });
    }
  }
};
</script>
<style lang="scss">
.signContent {
  width: 100%;
  .headerLogin {
    margin-top: 18px;
    font-size: 16px;
    .cols {
      color: #1d5a33;
      font-size: 16px;
    }
    .cols:hover {
      color: #248f47;
      cursor: pointer;
    }
  }
  .signindex {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #f4f4f4;
    .botcolor {
      margin-top: 60px;
    }
    .logincontent {
      margin-top: 40px;
      .headerTitle {
        width: 600px;
        height: 40px;
        line-height: 40px;
        margin: 40px auto;
        text-align: center;
        border: 1px solid #1d5a33;
        border-radius: 6px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
        margin-bottom: 50px;
        .one {
          width: 50%;
          height: 100%;
        }
        .two {
          width: 50%;
          height: 100%;
        }
        .active {
          width: 50%;
          height: 100%;
          background-color: #1d5a33;
          color: #fff;
          border: 1px solid #1d5a33;
          border-radius: 6px 0 0 6px;
        }
        .actives {
          width: 50%;
          height: 100%;
          border: 1px solid #1d5a33;
          background-color: #1d5a33;
          color: #fff;
          border-radius: 0 6px 6px 0;
        }
      }
      .formsign {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #f4f4f4;
        display: flex;
        justify-content: center;
        .el-button {
          height: 40px;
        }
        .codes {
          text-align: center;
          font-size: 16px;
        }
        .codeImg {
          margin-top: 30px;
          text-align: center;
          img {
            width: 190px;
            height: 75px;
          }
        }
        .codesy {
          color: #26a2ff;
          text-align: center;
          position: absolute;
          left: 125px;
          font-size: 13px;
          width: 69px;
        }
        .kbq {
          font-size: 15px;
          margin-top: 20px;
          text-align: center;
          margin-bottom: 10px;
        }
        .picwid.el-input {
          width: 100px;
          .el-input__inner {
            width: 100px;
          }
        }
        .codewid {
          width: 100px;
          display: inline-block;
          img {
            width: 100%;
          }
        }
        .el-steps--horizontal {
          padding: 0 40px;
          margin-top: 20px;
        }
        .el-form-item {
          margin-bottom: 25px;
        }
      }
      .signsuccess {
        display: flex;
        justify-content: center;
        align-content: center;
        padding-top: 100px;
        height: 520px;
        margin: auto;
        width: 1200px;
        border-bottom: 1px solid rgb(232, 232, 232);
        img {
          vertical-align: middle;
        }
        .logins {
          font-size: 12px;
          color: #999;
          margin-left: 50px;
        }
      }
    }
    .el-input__inner {
      border: 1px solid #1d5a33;
    }
  }
  .el-dialog__body {
    text-align: center;
  }
  .elbtn {
    margin-top: 30px;
    .rightBtn {
      width: 30%;
    }
    .titlecolor {
      color: #1d5a33;
      font-size: 12px;
    }
    .colorcur {
      color: #1d5a33;
      font-size: 14px;
    }
    .colorcur:hover {
      color: #248f47;
    }
  }
  .el-form-item__label {
    padding-right: 50px;
    // font-size: 16px;
    color: #1d5a33;
  }
  .posit {
    position: relative;
    .drag_verify {
      position: absolute;
      left: 50%;
      margin-left: -132px;
    }
  }
}
</style>
